// #564: Persönliche Einstellungen je Benutzer, gespeichert auf dem Server
// (GET/PATCH /api/user/settings) und damit auf allen Geräten gleich.
//
// Der Stand liegt hier einmal für die ganze Seite. Geladen wird er nach der
// Anmeldung (EinstellungenAbgleich in App.js, das Dashboard stößt es
// ebenfalls an), geändert wird er nur über aendereEinstellungen(): Die
// Änderung nennt nur ihre eigenen Schlüssel, der Server führt zusammen und
// liefert den ganzen neuen Stand zurück. Wer sich für den Stand interessiert,
// nimmt useBenutzerEinstellungen().
import { useEffect, useState } from 'react';
import apiService from './apiService';

const EREIGNIS = 'benutzerEinstellungen';

let stand = null; // null = noch nicht geladen
let pending = null;

function setzeStand(neu) {
  stand = neu && typeof neu === 'object' ? neu : {};
  try { window.dispatchEvent(new CustomEvent(EREIGNIS, { detail: stand })); } catch (_) {}
  return stand;
}

/** Der zuletzt bekannte Stand, oder null, solange nichts geladen ist. */
export function einstellungenStand() {
  return stand;
}

/** Lädt den Stand einmal je Seite; parallele Aufrufe teilen sich die Anfrage. */
export async function ladeEinstellungen() {
  if (stand) return stand;
  if (!pending) {
    pending = (async () => {
      try {
        const antwort = await apiService.getUserSettings();
        return setzeStand(antwort && antwort.settings);
      } finally {
        pending = null;
      }
    })();
  }
  return pending;
}

/** Speichert eine Änderung (nur die genannten Schlüssel, null nimmt heraus). */
export async function aendereEinstellungen(aenderung) {
  const antwort = await apiService.patchUserSettings(aenderung);
  return setzeStand(antwort && antwort.settings);
}

/** Der Stand als Hook: null bis zum ersten Laden, danach jede Änderung. */
export function useBenutzerEinstellungen() {
  const [aktuell, setAktuell] = useState(stand);
  useEffect(() => {
    const beiWechsel = (e) => setAktuell(e.detail);
    window.addEventListener(EREIGNIS, beiWechsel);
    if (stand) setAktuell(stand);
    return () => window.removeEventListener(EREIGNIS, beiWechsel);
  }, []);
  return aktuell;
}

// Nur für Tests: jede Testdatei beginnt ohne geladenen Stand.
export function zuruecksetzenFuerTests() {
  stand = null;
  pending = null;
}
